import React, { useEffect } from 'react';
import actions from 'actions';
import { useSpotPhotos } from '../useSpotPhotos';
import './styles.scss';

const MainPhotoForm = ({ spot, onChange, onClose }) => {
  const { unsplashPhotos, userPhotos, isReady } = useSpotPhotos(spot);

  const editMainPhotoId = id => {
    if (spot.mainPhotoId === id) {
      onClose();
    } else {
      const p = actions.spots.edit(spot, { mainPhotoId: id });
      actions.promises.add(p, 'long');
      onChange({ spotId: spot.id, mainPhotoId: id });
    }
  };

  // A spot with exactly one photo has no choice to make, so it is made here. The
  // photos used to arrive with the spot and a 10 ms timer was enough to wait for
  // the render; they are read one spot at a time now, so this waits for them
  // instead of for the clock.
  useEffect(() => {
    if (!isReady) {
      return;
    }

    const onlyOneUnsplash = unsplashPhotos.length === 1 && userPhotos.length === 0;
    const onlyOneUser = unsplashPhotos.length === 0 && userPhotos.length === 1;

    if (onlyOneUnsplash || onlyOneUser) {
      setTimeout(() => {
        const image = document.querySelector('.MainPhotoForm img');

        if (image) {
          image.click();
        }
      }, 10);
    }
  }, [isReady, unsplashPhotos.length, userPhotos.length]);

  useEffect(() => {
    const _onKeyPress = e => {
      if (e.key === 'Escape') {
        onClose();
        return;
      }

      const actionButton = document.querySelector(`.MainPhotoForm [data-action-key="${e.key}"]`);
      // event.metaKey is CMD (CMD + 3, for example)
      if (actionButton && !e.metaKey && actionButton.click) {
        e.preventDefault();
        actionButton.click();
      }
    };

    document.addEventListener('keydown', _onKeyPress, false);

    return () => {
      document.removeEventListener('keydown', _onKeyPress, false);
    };
  }, []);

  let actionKey = 0;

  return (
    <div className="MainPhotoForm">
      <div data-spot-id={spot.id}>Spot Id: {spot.id}</div>

      <h1 data-unsplash-count={unsplashPhotos.length}>Unsplash ({unsplashPhotos.length})</h1>
      {unsplashPhotos.map(x => {
        actionKey++;

        return (
          <img
            key={x.id}
            data-id={x.id}
            data-action-key={actionKey}
            style={spot.mainPhotoId === x.id ? { border: '2px solid red' } : undefined}
            src={x.urls.regular}
            alt={spot.name}
            onClick={() => editMainPhotoId(x.id)}
          />
        );
      })}

      <h1 data-user-count={userPhotos.length}>User Photos ({userPhotos.length})</h1>
      {userPhotos.map(x => {
        actionKey++;

        return (
          <img
            key={x.id}
            data-id={x.id}
            data-action-key={actionKey}
            style={spot.mainPhotoId === x.id ? { border: '2px solid red' } : undefined}
            src={x.url
              .replace('.jpg', '.webp')
              .replace(
                'https://storage.googleapis.com/mari-a5cc7.appspot.com',
                'https://statics.getnofilter.com'
              )}
            alt={spot.name}
            onClick={() => editMainPhotoId(x.id)}
          />
        );
      })}
    </div>
  );
};

export default MainPhotoForm;
